export enum CSSClasses {
  EmButton = 'cap-button',
  EmIconButton = 'cap-icon-button',
  ButtonPrimary = 'ui-button-primary',
  ButtonSecondary = 'ui-button-secondary',
  ButtonError = 'ui-button-error',
  ButtonSuccess = 'ui-button-success',
  ButtonWarning = 'ui-button-warning',
}
